import {
    FETCH_OFFER_BEGIN,
    FETCH_OFFER_SUCCESS,
    FETCH_OFFER_ERROR
} from '../actions/promoActions';

const defaultOfferState = {
    offer: null
};

export const offer = (state = defaultOfferState, action) => {
    switch (action.type) {
        case FETCH_OFFER_BEGIN:
            return {
                ...state,
                loading: true
            };
        case FETCH_OFFER_SUCCESS:
            return {
                ...state,
                loading: false,
                offer: action.payload.offer
            };
        case FETCH_OFFER_ERROR:
            return {
                ...state,
                loading: false,
                offer: null
            };

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/offer.js